import React from "react";
import { Modal } from "./Modal"

interface Props extends Omit<React.HTMLAttributes<HTMLButtonElement>, "onClick"> {
    modalContent: React.ReactNode;
    header?: React.ReactNode;
    verticallyCenteredModal?: boolean;
    onShow?: () => void;
    onHide?: () => void;
    forceReload?: boolean;
    size?: "sm" | "lg" | "xl" | "fullscreen"
}

export class OpenModalButton extends React.Component<Props> {
    private modalRef = React.createRef<Modal>();

    private click = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.modalElement().open();
        this.forceUpdate();
    }

    private modalElement() {
        return this.modalRef.current!;
    }

    public close() {
        this.modalElement().close();
    }

    render() {
        const { modalContent, header, verticallyCenteredModal, forceReload, onShow, onHide, ...buttonProps } = this.props;

        return (
            <>
                <button
                    {...buttonProps}
                    type="button"
                    onClick={this.click}
                />
                <Modal ref={this.modalRef}
                    forceReload={forceReload}
                    verticallyCentered={verticallyCenteredModal}
                    onHide={onHide}
                    onShow={onShow}
                    header={header}
                    size={this.props.size}
                >
                    {this.props.modalContent}
                </Modal>
            </>
        );
    }
}

export default OpenModalButton;